import Vue from "vue";
import Router from "vue-router";
const _import = require("./_import_" + process.env.NODE_ENV);
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// 在development-env中不使用延迟加载，因为延迟加载太多页面会导致webpack热更新太慢。 所以只有在生产中使用延迟加载;
Vue.use(Router);

import Layout from "../views/layout/Layout";

export const constantRouterMap = [
  {
    path: "/404",
    component: _import("404"),
    hidden: true
  },
  {
    path: "/",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/globalRaceRankBoard",
        component: _import("globalRaceRankBoard/index")
      },
      {
        path: "/dynamicRankBoard",
        component: _import("dynamicRankBoard/global")
      },
      {
        path: "/drb",
        component: _import("dynamicRankBoard/global")
      },
      {
        path: "/rankBoard",
        component: _import("commonRankBoard/index")
      },
      {
        path: "/r/:channel",
        component: _import("commonRankBoard/index")
      },
      {
        path: "/wxRankBoard",
        component: _import("wxRankBoard/index")
      },
      // 全国赛决赛排行榜
      {
        path: "/d/:channel",
        component: _import("dynamicRankBoard/index")
      },
      {
        path: "/:channel",
        component: _import("commonRankBoard/index")
      }
    ]
  },
  {
    path: "*",
    redirect: "/",
    hidden: true
  }
];

export const RouterBulala = [];

export default new Router({
  mode: "history", // 后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js